import { render, staticRenderFns } from "./TableBox.vue?vue&type=template&id=4036fc52&scoped=true&"
import script from "./TableBox.vue?vue&type=script&lang=js&"
export * from "./TableBox.vue?vue&type=script&lang=js&"
import style0 from "./TableBox.vue?vue&type=style&index=0&id=4036fc52&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4036fc52",
  null
  
)

export default component.exports